import { Button } from '@innovyze/stylovyze';
import { Grid } from '@mui/material';
import styled from 'styled-components';

export const DeleteButton = styled(Button)`
	color: #ffffff;
	background-color: #e66b45;
	margin-right: 13px;
	width: 79px;
	height: 35px;
`;

export const CancelButton = styled(Button)`
	color: #252f33;
	background-color: #d6dddf;
	margin-right: 2px;
	width: 79px;
	height: 35px;
`;

export const StyledGrid = styled(Grid)`
	display: flex;
	justify-content: flex-end;
`;

export const Container = styled.div`
	padding: 18px;
	background-color: white;
	min-height: 12vh;
	min-width: 37vw;
`;

export const Exclamation = styled.span`
	border-radius: 50%;
	width: 20px;
	height: 20px;
	margin-right: 12px;
	background: #4a6067;
	color: #ffffff;
	line-height: 20px;
	display: inline-block;
	text-align: center;
	vertical-align: middle;
`;

export const Header = styled.h2`
	color: #e66b45;
	font-family: 'Segoe UI', Roboto, sans-serif;
	font-style: normal;
	font-weight: 600;
	font-size: 18px;
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin: 0px;
`;

export const StyledText = styled.p`
	color: #4a6067;
	font-family: Segoe UI, Roboto, sans-serif;
	font-style: normal;
	font-weight: normal;
	font-size: 16px;
	line-height: 20px;
	width: 542px;
	height: 75px;
`;
